import React from "react";
import { Clock, ScrollText } from "lucide-react";
import { Link } from "react-router-dom";

const CoursePageCard = ({ course }) => (
  <div className="bg-white border border-gray-100 rounded-2xl overflow-hidden flex flex-col">
    <div className="p-5 flex flex-col gap-3 flex-1">
      {/* Badges */}
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium px-3 py-1 rounded-full bg-red-50 text-red-700">
          {course.type}
        </span>
        {course.isNew && (
          <span className="text-sm font-medium px-3 py-1 rounded-full bg-green-50 text-green-700">
            New
          </span>
        )}
      </div>

      {/* Title */}
      <h3 className="font-medium text-gray-900 leading-snug text-xl sm:text-2xl">
        {course.title}
      </h3>

      {/* Description */}
      <p className="text-sm sm:text-base text-gray-500 leading-relaxed">
        {course?.description}
      </p>

      {/* Meta */}
      <div className="flex gap-4">
        {
          course?.duration &&(
        <div className="flex items-center gap-1.5 text-[13px] text-gray-500">
          <Clock className="w-3.5 h-3.5 text-red-500" />
          {course.duration}
        </div>
          )
        }
        {
          course?.certificates && (
        <div className="flex items-center gap-1.5 text-[13px] text-gray-500">
          <ScrollText className="w-3.5 h-3.5 text-red-500" />
          {course.certificates} Certificates
        </div>
          )
        }
      </div>

      <hr className="border-gray-100" />

      {/* Highlights — optional */}
      {course.highlights?.length > 0 && (
        <>
          <div>
            <p className="text-sm font-medium uppercase tracking-wide text-gray-400 hover:text-gray-500 duration-500 mb-2.5">
               Highlights
            </p>
            <div className="flex flex-wrap gap-1.5">
              {course.highlights.map((h, i) => (
                <span
                  key={i}
                  className="text-sm px-2.5 py-1 rounded-full bg-gray-50 text-gray-500 border border-gray-100"
                >
                  {h}
                </span>
              ))}
            </div>
          </div>
          <hr className="border-gray-100" />
        </>
      )}

      {/* Contents */}
      <div>
        <p className="text-sm font-medium uppercase tracking-wide text-gray-400 hover:text-gray-500 duration-500 mb-2">
          Course contents
        </p>
        <ul className="flex flex-col gap-2">
          {course.contents?.map((item, idx) => (
            <li
              key={idx}
              className="flex items-start gap-2 text-sm text-gray-700 leading-snug"
            >
              <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-red-500 flex-shrink-0" />
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>

    {/* Footer CTA */}
    <div className="px-5 pb-5 pt-3 border-t border-gray-100 mt-auto w-full max-w-full">
      <Link to="/contact" className="block w-full text-center py-2 text-sm font-medium text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
        Enquire about this course →
      </Link>
    </div>
  </div>
);

export default CoursePageCard;

//========================================= ANEES BRO CODE ==============================================================
// const CoursePageCard = ({ course }) => (
//   <div className="bg-[#ffffff] border-2 rounded-lg p-6 mt-5 ">
//     <div className="mb-5">
//       <p className='text-sm text-red-600 mb-4 bg-red-100 w-fit py-1 px-3 rounded-full'>{course.type}</p>
//       <h3 className="text-xl sm:text-2xl  font-semibold text-gray-800">{course.title}</h3>
//       {/* {course.isNew && (
//         <span className="px-2 py-1 text-sm bg-green-500 text-white rounded">NEW</span>
//       )} */}
//     </div>
//     <p className="text-gray-800 mb-4">{course.description}</p>
//     <div className="flex gap-10 text-sm text-gray-600 mb-4">
//       <div className="flex items-center gap-2">
//         <Clock className="w-4 h-4 text-red-500" />
//         <span>{course.duration}</span>
//       </div>
//       <div className="flex items-center gap-2">
//         <ScrollText className="w-4 h-4 text-red-500" />
//         <span>{course?.certificates} Certificates</span>
//       </div>
//     </div>
//     <div className='flex items-center gap-2 mb-2'>
//         <GraduationCap className="w-5 h-5 text-red-500" />
//         <h4 className="text-lg font-semibold pt-1 ">Course Contents:</h4>
//     </div>
//     <ul className="list-disc ml-5 text-sm text-gray-800">
//       {course.contents?.map((item, idx) => (
//         <li key={idx}>{item}</li>
//       ))}
//     </ul>
//   </div>
// );

// export default CoursePageCard;

//========================================= ANEES BRO CODE ==============================================================
